import { isNullOrEmpty } from "./string-helper";
const uuidv4 = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
};
export const Guid = {
    IsEmpty: (value) => isNullOrEmpty(value) || value === Guid.Empty,
    IsNotEmpty: (value) => Guid.IsValid(value) && !Guid.IsEmpty(value),
    NewGuid: () => {
        let id = uuidv4();
        return id;
    },
    IsValid: (value) => {
        if (isNullOrEmpty(value)) {
            return false;
        }
        const pattern = new RegExp('^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$', 'i');
        return pattern.test(value);
    },
    PrimaryKey: `FFFFFFFF-FFFF-FFFF-FFFF-FFFFFFFFFFFF`,
    Empty: '00000000-0000-0000-0000-000000000000'
};
